import { Component, Input } from '@angular/core';

@Component({
  selector: 'portal-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() isLogin = false;
  public date: Date = new Date();
}
